<template>
  <div class="after-sale-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="订单号">
          <el-input v-model="filterForm.order_dh" placeholder="请输入订单号" clearable />
        </el-form-item>
        <!-- <el-form-item label="售后状态">
          <el-select v-model="filterForm.status" placeholder="全部" clearable>
            <el-option label="待审核" value="待审核" />
            <el-option label="审核通过" value="审核通过" />
            <el-option label="退款中" value="退款中" />
            <el-option label="已退款" value="已退款" />
            <el-option label="已拒绝" value="已拒绝" />
            <el-option label="已取消" value="已取消" />
          </el-select>
        </el-form-item> -->
        <el-form-item label="申请时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 订单表格 -->
    <el-card class="table-card" shadow="never" style="height:70vh; overflow: auto;">
      <el-table
        :data="orderList"
        v-loading="loading"
        style="width: 100%"
        border
        height="60vh"
        stripe
        row-key="id"
        @row-click="viewOrderDetail"
        class="order-table"
      >
        <!-- 展开列：商品明细 -->
        <el-table-column type="expand" width="50">
          <template slot-scope="props">
            <div class="expand-content">
              <div class="expand-title">
                <span>商品明细</span>
                <span class="expand-count">共 {{ props.row.mx_list?.length || 0 }} 件商品</span>
              </div>
              <el-table
                :data="props.row.mx_list || []"
                size="small"
                border
                stripe
                style="width: 100%"
              >
                <el-table-column type="index" label="序号" width="60" align="center" />
                <el-table-column prop="comlist_v1" label="商品名称" min-width="200" />
                <el-table-column prop="comlist_s1" label="数量" width="100" align="center" />
                <el-table-column prop="comlist_f1" label="单价" width="130" align="right">
                  <template slot-scope="scope">
                    ¥{{ parseFloat(scope.row.comlist_f1 || 0).toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column label="小计" width="150" align="right">
                  <template slot-scope="scope">
                    ¥{{ (parseFloat(scope.row.comlist_f1 || 0) * parseInt(scope.row.comlist_s1 || 0)).toFixed(2) }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>

        <!-- 订单号 -->
        <el-table-column prop="order_dh" label="订单号" min-width="160" sortable>
          <template slot-scope="scope">
            <span class="order-id-text">{{ scope.row.order_dh || scope.row.id || '--' }}</span>
          </template>
        </el-table-column>

        <!-- 店铺 -->
        <el-table-column prop="sh_name" label="店铺" width="120" show-overflow-tooltip />

        <!-- 商品信息 -->
        <el-table-column label="商品信息" min-width="200">
          <template slot-scope="scope">
            <div class="product-info">
              <div class="product-name">{{ scope.row.comlist_v2 || scope.row.comlist_v5 || '--' }}</div>
              <div v-if="scope.row.comlist_v5 && scope.row.comlist_v5 !== scope.row.comlist_v2" class="product-desc">
                {{ scope.row.comlist_v5 }}
              </div>
            </div>
          </template>
        </el-table-column>

        <!-- 退款金额 -->
        <el-table-column label="退款金额" width="130" align="right" sortable prop="refund_amount">
          <template slot-scope="scope">
            <span class="refund-price">¥{{ formatPrice(scope.row.refund_amount || scope.row.jine_all || 0) }}</span>
          </template>
        </el-table-column>

        <!-- 售后状态 -->
        <el-table-column label="售后状态" width="110" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)" size="small" effect="dark">
              {{ getDisplayStatus(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 申请时间 -->
        <el-table-column prop="comlist3" label="申请时间" width="165" sortable>
          <template slot-scope="scope">
            {{ formatTime(scope.row.comlist3) }}
          </template>
        </el-table-column>

        <!-- 操作 -->
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click.stop="viewOrderDetail(scope.row)">
              查看详情
            </el-button>
            <!-- <el-button
              v-if="showCancelButton(scope.row)"
              size="mini"
              type="danger"
              plain
              @click.stop="cancelApply(scope.row)"
            >
              取消申请
            </el-button> -->
          </template>
        </el-table-column>

        <!-- 空状态 -->
        <template slot="empty">
          <div class="empty-order">
            <i class="el-icon-document" style="font-size: 48px; color: #ddd;"></i>
            <p style="color: #999; margin-top: 8px;">暂无售后订单</p>
          </div>
        </template>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- 订单详情弹窗 -->
    <el-dialog title="售后订单详情" :visible.sync="dialogVisible" width="70%" top="5vh">
      <el-descriptions :column="2" border v-if="currentOrder">
        <el-descriptions-item label="订单号">{{ currentOrder.order_dh || currentOrder.id || '--' }}</el-descriptions-item>
        <el-descriptions-item label="店铺">{{ currentOrder.sh_name || '--' }}</el-descriptions-item>
        <el-descriptions-item label="售后状态">
          <el-tag :type="getStatusType(currentOrder.status)">
            {{ getDisplayStatus(currentOrder.status) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="退款金额">
          <span style="color: #ee530c; font-weight: bold;">¥{{ formatPrice(currentOrder.refund_amount || currentOrder.jine_all || 0) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="申请时间">{{ currentOrder.comlist3 || '--' }}</el-descriptions-item>
        <el-descriptions-item label="联系方式">{{ currentOrder.comlist_v3 || '--' }}</el-descriptions-item>
        <el-descriptions-item label="收货人">{{ currentOrder.comlist_v2 || '--' }}</el-descriptions-item>
        <el-descriptions-item label="收货地址" :span="2">{{ currentOrder.comlist_v4 || '--' }}</el-descriptions-item>
        <el-descriptions-item label="售后原因" :span="2">{{ currentOrder.reason || currentOrder.comlist_v5 || '--' }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ currentOrder.remark || '--' }}</el-descriptions-item>
      </el-descriptions>

      <div v-if="currentOrder && currentOrder.mx_list && currentOrder.mx_list.length" style="margin-top: 20px;">
        <h4>商品明细</h4>
        <el-table :data="currentOrder.mx_list" size="small" border stripe>
          <el-table-column type="index" label="序号" width="60" />
          <el-table-column prop="comlist_v1" label="商品名称" />
          <el-table-column prop="comlist_s1" label="数量" width="100" align="center" />
          <el-table-column prop="comlist_f1" label="单价" width="120" align="right">
            <template slot-scope="scope">¥{{ parseFloat(scope.row.comlist_f1 || 0).toFixed(2) }}</template>
          </el-table-column>
          <el-table-column label="小计" width="150" align="right">
            <template slot-scope="scope">
              ¥{{ (parseFloat(scope.row.comlist_f1 || 0) * parseInt(scope.row.comlist_s1 || 0)).toFixed(2) }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <span slot="footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import xcxrequest from '@/utils/xcxrequest'

export default {
  name: 'AfterSaleOrderListPC',
  data () {
    const now = new Date()
    const end = new Date(now)
    const start = new Date(now)
    start.setMonth(now.getMonth() - 1)
    const format = (d) => {
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
    return {
      loading: false,
      orderList: [],
      filterForm: {
        order_dh: '',
        status: ''
      },
      dateRange: [format(start), format(end)],
      currentPage: 1,
      pageSize: 10,
      total: 0,

      // 订单详情
      dialogVisible: false,
      currentOrder: null
    }
  },

  mounted () {
    this.loadAfterSaleOrders()
  },

  methods: {
    // ---------- 加载售后订单列表 ----------
    async loadAfterSaleOrders () {
      this.loading = true
      try {
        const crmId = localStorage.getItem('crm_id')
        const memUser = localStorage.getItem('user_name')

        if (!crmId || !memUser) {
          this.$message.warning('请先登录')
          this.loading = false
          return
        }

        const params = {
          crm_id: crmId,
          mem_user: memUser,
          page: this.currentPage,
          pageSize: this.pageSize,
          start_date: this.dateRange && this.dateRange.length === 2 ? this.dateRange[0] : '',
          end_date: this.dateRange && this.dateRange.length === 2 ? this.dateRange[1] : '',
          ...this.filterForm
        }

        // 移除空值
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key]
          }
        })

        const res = await xcxrequest.post('/gouwu/com_tui_list.php', params)
        console.log('售后订单列表:', res)

        if (res.code === 0) {
          this.orderList = res.com_tui || []
          this.total = res.total || this.orderList.length
        } else {
          this.$message.error(res.msg || '获取售后订单失败')
          this.orderList = []
          this.total = 0
        }
      } catch (error) {
        console.error('加载售后订单失败:', error)
        // this.$message.error('网络错误，请重试')
        this.orderList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },

    // ---------- 筛选与分页 ----------
    handleSearch () {
      this.currentPage = 1
      this.loadAfterSaleOrders()
    },

    handleReset () {
      this.filterForm = { order_dh: '', status: '' }
      this.dateRange = []
      this.currentPage = 1
      this.loadAfterSaleOrders()
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.loadAfterSaleOrders()
    },

    handleCurrentChange (val) {
      this.currentPage = val
      this.loadAfterSaleOrders()
    },

    // ---------- 工具函数 ----------
    formatPrice (price) {
      if (!price && price !== 0) return '0.00'
      const num = parseFloat(price)
      if (isNaN(num)) return '0.00'
      return num.toFixed(2)
    },

    formatTime (timeStr) {
      if (!timeStr) return '--'
      try {
        const date = new Date(timeStr.replace(/-/g, '/'))
        if (!isNaN(date.getTime())) {
          const month = (date.getMonth() + 1).toString().padStart(2, '0')
          const day = date.getDate().toString().padStart(2, '0')
          const hours = date.getHours().toString().padStart(2, '0')
          const minutes = date.getMinutes().toString().padStart(2, '0')
          return `${month}-${day} ${hours}:${minutes}`
        }
        return timeStr
      } catch {
        return timeStr
      }
    },

    // ---------- 状态映射 ----------
    getDisplayStatus (status) {
      if (!status) return '待审核'
      const map = {
        待审核: '待审核',
        审核通过: '审核通过',
        退款中: '退款中',
        已退款: '已退款',
        已拒绝: '已拒绝',
        已取消: '已取消'
      }
      return map[status] || status
    },

    getStatusType (status) {
      if (!status) return 'warning'
      const map = {
        待审核: 'warning',
        审核通过: 'primary',
        退款中: 'info',
        已退款: 'success',
        已拒绝: 'danger',
        已取消: 'info'
      }
      return map[status] || 'info'
    },

    // ---------- 操作按钮 ----------
    showCancelButton (row) {
      // 只有待审核状态才显示取消按钮
      return row.status === '待审核' || !row.status
    },

    // ---------- 取消申请 ----------
    async cancelApply (row) {
      try {
        await this.$confirm('确定要取消该售后申请吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const res = await xcxrequest.post('/gouwu/com_tui_cancel.php', {
          id: row.id
        })

        if (res.code === 0) {
          this.$message.success('取消成功')
          this.loadAfterSaleOrders()
        } else {
          this.$message.error(res.msg || '取消失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('取消售后申请失败:', error)
          this.$message.error('网络错误，请重试')
        }
      }
    },

    // ---------- 查看详情 ----------
    viewOrderDetail (row) {
      this.currentOrder = row
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.after-sale-container {
  padding: 20px;
  background-color: #f0f2f6;
  height: 90vh;
  overflow-y: auto;
  box-sizing: border-box;

  .filter-card {
    .filter-form {
      margin-bottom: 0;
    }
  }

  .table-card {
    .order-table {
      :deep(.el-table__expanded-cell) {
        padding: 16px 20px;
        box-sizing: border-box;
        background-color: #fafbfc;
      }

      .expand-content {
        .expand-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
          font-size: 14px;
          font-weight: 600;
          color: #303133;

          .expand-count {
            font-weight: 400;
            color: #909399;
            font-size: 13px;
          }
        }
      }

      .order-id-text {
        font-weight: 500;
        color: #303133;
        font-size: 13px;
      }

      .refund-price {
        color: #ee530c;
        font-weight: 700;
        font-size: 15px;
      }

      .product-info {
        .product-name {
          font-size: 14px;
          color: #303133;
          line-height: 1.4;
        }
        .product-desc {
          font-size: 12px;
          color: #909399;
          margin-top: 4px;
          line-height: 1.3;
        }
      }

      :deep(.el-table__row) {
        cursor: pointer;
        transition: background-color 0.15s;

        &:hover {
          background-color: #f5f7fa !important;
        }
      }

      .el-button--mini {
        margin: 2px 2px;
      }
    }

    .empty-order {
      text-align: center;
      padding: 40px 0;
      i {
        display: block;
      }
      p {
        margin: 0;
      }
    }

    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }

  // 详情弹窗样式
  :deep(.el-descriptions) {
    .el-descriptions__label {
      width: 120px;
      font-weight: 600;
    }
  }
}
</style>
